// extracted by mini-css-extract-plugin
export var root = "Spinner-module--root--3uUbM";
export var rotate = "Spinner-module--rotate--3eIT6";
export var large = "Spinner-module--large--1nNB_";
export var medium = "Spinner-module--medium--1xXwB";
export var small = "Spinner-module--small--84Vqv";
export var secondary = "Spinner-module--secondary--KVck5";